import clsx from 'clsx';
import { Button } from '@clay-run/glaze/button';
import { Strong, Text } from '@clay-run/glaze/text';

export type EmptyStateProps = {
  title: string;
  /** One line, Extra Small, content-tertiary. */
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
};

/** Glaze ships no EmptyState — port: title, one line, at most one secondary action. */
export function EmptyState({ title, description, actionLabel, onAction, className }: EmptyStateProps) {
  return (
    <div className={clsx('flex flex-col items-center justify-center gap-2 px-4 py-10 text-center', className)}>
      <Strong className="text-sm">{title}</Strong>
      {description && <Text size="xs" variant="tertiary">{description}</Text>}
      {actionLabel && onAction && (
        <Button size="sm" variant="secondary" className="mt-2" onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
}
